import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp.js";
import { CriticalityLevel } from "./common.js";
import { DeploymentStatus } from "./common.js";
import { ConnectorType } from "./common.js";
import { CurrentType } from "./common.js";
import { Location } from "./common.js";
import { Struct } from "../../google/protobuf/struct.js";
import { PowerSpecification } from "./common.js";
import { ChargingRateUnit } from "./common.js";
import { Timestamps } from "./common.js";
import { DeviceType } from "./common.js";
// @generated message type with reflection information, may provide speed optimized methods
class DeviceModel$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceModel", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["devices.v1.DeviceType", DeviceType, "DEVICE_TYPE_"] },
            { no: 3, name: "timestamps", kind: "message", T: () => Timestamps }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.DeviceType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* devices.v1.Timestamps timestamps */ 3:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.DeviceType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* devices.v1.Timestamps timestamps = 3; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceModel
 */
export const DeviceModel = new DeviceModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Device$Type extends MessageType {
    constructor() {
        super("devices.v1.Device", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["devices.v1.DeviceType", DeviceType, "DEVICE_TYPE_"] },
            { no: 8, name: "station", kind: "message", T: () => Station },
            { no: 9, name: "evse", kind: "message", T: () => Evse },
            { no: 10, name: "connector", kind: "message", T: () => Connector },
            { no: 11, name: "stationary_battery", kind: "message", T: () => StationaryBattery },
            { no: 13, name: "errors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceError }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.type = 0;
        message.errors = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.DeviceType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* devices.v1.Station station */ 8:
                    message.station = Station.internalBinaryRead(reader, reader.uint32(), options, message.station);
                    break;
                case /* devices.v1.Evse evse */ 9:
                    message.evse = Evse.internalBinaryRead(reader, reader.uint32(), options, message.evse);
                    break;
                case /* devices.v1.Connector connector */ 10:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* devices.v1.StationaryBattery stationary_battery */ 11:
                    message.stationaryBattery = StationaryBattery.internalBinaryRead(reader, reader.uint32(), options, message.stationaryBattery);
                    break;
                case /* repeated devices.v1.DeviceError errors */ 13:
                    message.errors.push(DeviceError.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.DeviceType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* devices.v1.Station station = 8; */
        if (message.station)
            Station.internalBinaryWrite(message.station, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Evse evse = 9; */
        if (message.evse)
            Evse.internalBinaryWrite(message.evse, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Connector connector = 10; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.StationaryBattery stationary_battery = 11; */
        if (message.stationaryBattery)
            StationaryBattery.internalBinaryWrite(message.stationaryBattery, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.DeviceError errors = 13; */
        for (let i = 0; i < message.errors.length; i++)
            DeviceError.internalBinaryWrite(message.errors[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.Device
 */
export const Device = new Device$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceCommunicationProtocol$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceCommunicationProtocol", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "timestamps", kind: "message", T: () => Timestamps }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.description = "";
        message.version = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string version */ 4:
                    message.version = reader.string();
                    break;
                case /* devices.v1.Timestamps timestamps */ 5:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string version = 4; */
        if (message.version !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.version);
        /* devices.v1.Timestamps timestamps = 5; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceCommunicationProtocol
 */
export const DeviceCommunicationProtocol = new DeviceCommunicationProtocol$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StationModel$Type extends MessageType {
    constructor() {
        super("devices.v1.StationModel", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "communication_protocol_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "communication_interval", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "dispatch_error_allowance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "dispatch_error_allowed_interval_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "sleep_dispatch_error_allowance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "charging_rate_unit", kind: "enum", T: () => ["devices.v1.ChargingRateUnit", ChargingRateUnit] },
            { no: 11, name: "power_spec", kind: "message", T: () => PowerSpecification },
            { no: 12, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 13, name: "protocol", kind: "message", T: () => DeviceCommunicationProtocol },
            { no: 14, name: "stations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Station },
            { no: 15, name: "model_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "supported_voltages", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 18, name: "specifications", kind: "message", T: () => Struct },
            { no: 20, name: "power_increment", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 21, name: "max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 22, name: "max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.manufacturer = "";
        message.modelName = "";
        message.communicationProtocolId = "";
        message.communicationInterval = 0;
        message.dispatchErrorAllowance = 0;
        message.dispatchErrorAllowedIntervalSeconds = 0;
        message.sleepDispatchErrorAllowance = 0;
        message.chargingRateUnit = 0;
        message.stations = [];
        message.modelYear = 0;
        message.supportedVoltages = [];
        message.powerIncrement = 0n;
        message.maxChargePower = 0n;
        message.maxDischargePower = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string manufacturer */ 2:
                    message.manufacturer = reader.string();
                    break;
                case /* string model_name */ 3:
                    message.modelName = reader.string();
                    break;
                case /* string communication_protocol_id */ 4:
                    message.communicationProtocolId = reader.string();
                    break;
                case /* int32 communication_interval */ 5:
                    message.communicationInterval = reader.int32();
                    break;
                case /* int32 dispatch_error_allowance */ 6:
                    message.dispatchErrorAllowance = reader.int32();
                    break;
                case /* int32 dispatch_error_allowed_interval_seconds */ 7:
                    message.dispatchErrorAllowedIntervalSeconds = reader.int32();
                    break;
                case /* int32 sleep_dispatch_error_allowance */ 8:
                    message.sleepDispatchErrorAllowance = reader.int32();
                    break;
                case /* devices.v1.ChargingRateUnit charging_rate_unit */ 9:
                    message.chargingRateUnit = reader.int32();
                    break;
                case /* devices.v1.PowerSpecification power_spec */ 11:
                    message.powerSpec = PowerSpecification.internalBinaryRead(reader, reader.uint32(), options, message.powerSpec);
                    break;
                case /* devices.v1.Timestamps timestamps */ 12:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* devices.v1.DeviceCommunicationProtocol protocol */ 13:
                    message.protocol = DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options, message.protocol);
                    break;
                case /* repeated devices.v1.Station stations */ 14:
                    message.stations.push(Station.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 model_year */ 15:
                    message.modelYear = reader.int32();
                    break;
                case /* repeated double supported_voltages */ 17:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.supportedVoltages.push(reader.double());
                    else
                        message.supportedVoltages.push(reader.double());
                    break;
                case /* google.protobuf.Struct specifications */ 18:
                    message.specifications = Struct.internalBinaryRead(reader, reader.uint32(), options, message.specifications);
                    break;
                case /* int64 power_increment */ 20:
                    message.powerIncrement = reader.int64().toBigInt();
                    break;
                case /* int64 max_charge_power */ 21:
                    message.maxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 max_discharge_power */ 22:
                    message.maxDischargePower = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string manufacturer = 2; */
        if (message.manufacturer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.manufacturer);
        /* string model_name = 3; */
        if (message.modelName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.modelName);
        /* string communication_protocol_id = 4; */
        if (message.communicationProtocolId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.communicationProtocolId);
        /* int32 communication_interval = 5; */
        if (message.communicationInterval !== 0)
            writer.tag(5, WireType.Varint).int32(message.communicationInterval);
        /* int32 dispatch_error_allowance = 6; */
        if (message.dispatchErrorAllowance !== 0)
            writer.tag(6, WireType.Varint).int32(message.dispatchErrorAllowance);
        /* int32 dispatch_error_allowed_interval_seconds = 7; */
        if (message.dispatchErrorAllowedIntervalSeconds !== 0)
            writer.tag(7, WireType.Varint).int32(message.dispatchErrorAllowedIntervalSeconds);
        /* int32 sleep_dispatch_error_allowance = 8; */
        if (message.sleepDispatchErrorAllowance !== 0)
            writer.tag(8, WireType.Varint).int32(message.sleepDispatchErrorAllowance);
        /* devices.v1.ChargingRateUnit charging_rate_unit = 9; */
        if (message.chargingRateUnit !== 0)
            writer.tag(9, WireType.Varint).int32(message.chargingRateUnit);
        /* devices.v1.PowerSpecification power_spec = 11; */
        if (message.powerSpec)
            PowerSpecification.internalBinaryWrite(message.powerSpec, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Timestamps timestamps = 12; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.DeviceCommunicationProtocol protocol = 13; */
        if (message.protocol)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocol, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.Station stations = 14; */
        for (let i = 0; i < message.stations.length; i++)
            Station.internalBinaryWrite(message.stations[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* int32 model_year = 15; */
        if (message.modelYear !== 0)
            writer.tag(15, WireType.Varint).int32(message.modelYear);
        /* repeated double supported_voltages = 17; */
        if (message.supportedVoltages.length) {
            writer.tag(17, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.supportedVoltages.length; i++)
                writer.double(message.supportedVoltages[i]);
            writer.join();
        }
        /* google.protobuf.Struct specifications = 18; */
        if (message.specifications)
            Struct.internalBinaryWrite(message.specifications, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* int64 power_increment = 20; */
        if (message.powerIncrement !== 0n)
            writer.tag(20, WireType.Varint).int64(message.powerIncrement);
        /* int64 max_charge_power = 21; */
        if (message.maxChargePower !== 0n)
            writer.tag(21, WireType.Varint).int64(message.maxChargePower);
        /* int64 max_discharge_power = 22; */
        if (message.maxDischargePower !== 0n)
            writer.tag(22, WireType.Varint).int64(message.maxDischargePower);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.StationModel
 */
export const StationModel = new StationModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Station$Type extends MessageType {
    constructor() {
        super("devices.v1.Station", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "location", kind: "message", T: () => Location },
            { no: 5, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 11, name: "deployment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "electric_supply", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "device", kind: "message", T: () => Device },
            { no: 7, name: "model", kind: "message", T: () => StationModel },
            { no: 8, name: "evses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Evse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.deploymentStatus = "";
        message.name = "";
        message.serialNumber = "";
        message.externalId = "";
        message.modelId = "";
        message.electricSupply = 0;
        message.evses = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.Location location */ 4:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* devices.v1.Timestamps timestamps */ 5:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* string deployment_status */ 11:
                    message.deploymentStatus = reader.string();
                    break;
                case /* string name */ 12:
                    message.name = reader.string();
                    break;
                case /* string serial_number */ 13:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 14:
                    message.externalId = reader.string();
                    break;
                case /* string model_id */ 15:
                    message.modelId = reader.string();
                    break;
                case /* double electric_supply */ 16:
                    message.electricSupply = reader.double();
                    break;
                case /* devices.v1.Device device */ 6:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* devices.v1.StationModel model */ 7:
                    message.model = StationModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                case /* repeated devices.v1.Evse evses */ 8:
                    message.evses.push(Evse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.Location location = 4; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Timestamps timestamps = 5; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Device device = 6; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.StationModel model = 7; */
        if (message.model)
            StationModel.internalBinaryWrite(message.model, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.Evse evses = 8; */
        for (let i = 0; i < message.evses.length; i++)
            Evse.internalBinaryWrite(message.evses[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string deployment_status = 11; */
        if (message.deploymentStatus !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.deploymentStatus);
        /* string name = 12; */
        if (message.name !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.name);
        /* string serial_number = 13; */
        if (message.serialNumber !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 14; */
        if (message.externalId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.externalId);
        /* string model_id = 15; */
        if (message.modelId !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.modelId);
        /* double electric_supply = 16; */
        if (message.electricSupply !== 0)
            writer.tag(16, WireType.Bit64).double(message.electricSupply);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.Station
 */
export const Station = new Station$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EvseModel$Type extends MessageType {
    constructor() {
        super("devices.v1.EvseModel", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "supports_sleep", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "charging_rate_unit", kind: "enum", T: () => ["devices.v1.ChargingRateUnit", ChargingRateUnit] },
            { no: 6, name: "power_spec", kind: "message", T: () => PowerSpecification },
            { no: 9, name: "zero_power_setpoints_allowed_per_transaction", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "standby_losses_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "variable_losses_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "phases", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "current_type", kind: "enum", T: () => ["devices.v1.CurrentType", CurrentType, "CURRENT_TYPE_"] },
            { no: 14, name: "charging_command_interface", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "peak_power_efficiency_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 18, name: "evses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Evse },
            { no: 19, name: "model_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "supported_voltages", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 22, name: "specifications", kind: "message", T: () => Struct },
            { no: 27, name: "power_efficiency", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "phase_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "zero_power_setpoints_allowed_per_session", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "efficiency_min_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 31, name: "efficiency_max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 32, name: "strict_min_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 33, name: "max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 34, name: "max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 35, name: "strict_min_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 36, name: "efficiency_min_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 37, name: "efficiency_max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 38, name: "charge_efficiency_at_min_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 39, name: "charge_efficiency_at_max_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 40, name: "discharge_efficiency_at_min_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 41, name: "discharge_efficiency_at_max_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.manufacturer = "";
        message.modelName = "";
        message.supportsSleep = false;
        message.chargingRateUnit = 0;
        message.zeroPowerSetpointsAllowedPerTransaction = false;
        message.standbyLossesW = 0n;
        message.variableLossesPercent = 0;
        message.phases = 0;
        message.currentType = 0;
        message.chargingCommandInterface = "";
        message.peakPowerEfficiencyPercent = 0;
        message.evses = [];
        message.modelYear = 0;
        message.supportedVoltages = [];
        message.powerEfficiency = 0;
        message.phaseType = "";
        message.zeroPowerSetpointsAllowedPerSession = 0;
        message.efficiencyMinChargePower = 0n;
        message.efficiencyMaxChargePower = 0n;
        message.strictMinChargePower = 0n;
        message.maxChargePower = 0n;
        message.maxDischargePower = 0n;
        message.strictMinDischargePower = 0n;
        message.efficiencyMinDischargePower = 0n;
        message.efficiencyMaxDischargePower = 0n;
        message.chargeEfficiencyAtMinPercent = 0;
        message.chargeEfficiencyAtMaxPercent = 0;
        message.dischargeEfficiencyAtMinPercent = 0;
        message.dischargeEfficiencyAtMaxPercent = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string manufacturer */ 2:
                    message.manufacturer = reader.string();
                    break;
                case /* string model_name */ 3:
                    message.modelName = reader.string();
                    break;
                case /* bool supports_sleep */ 4:
                    message.supportsSleep = reader.bool();
                    break;
                case /* devices.v1.ChargingRateUnit charging_rate_unit */ 5:
                    message.chargingRateUnit = reader.int32();
                    break;
                case /* devices.v1.PowerSpecification power_spec */ 6:
                    message.powerSpec = PowerSpecification.internalBinaryRead(reader, reader.uint32(), options, message.powerSpec);
                    break;
                case /* bool zero_power_setpoints_allowed_per_transaction */ 9:
                    message.zeroPowerSetpointsAllowedPerTransaction = reader.bool();
                    break;
                case /* int64 standby_losses_w */ 10:
                    message.standbyLossesW = reader.int64().toBigInt();
                    break;
                case /* double variable_losses_percent */ 11:
                    message.variableLossesPercent = reader.double();
                    break;
                case /* int32 phases */ 12:
                    message.phases = reader.int32();
                    break;
                case /* devices.v1.CurrentType current_type */ 13:
                    message.currentType = reader.int32();
                    break;
                case /* string charging_command_interface */ 14:
                    message.chargingCommandInterface = reader.string();
                    break;
                case /* double peak_power_efficiency_percent */ 15:
                    message.peakPowerEfficiencyPercent = reader.double();
                    break;
                case /* devices.v1.Timestamps timestamps */ 17:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* repeated devices.v1.Evse evses */ 18:
                    message.evses.push(Evse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 model_year */ 19:
                    message.modelYear = reader.int32();
                    break;
                case /* repeated double supported_voltages */ 21:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.supportedVoltages.push(reader.double());
                    else
                        message.supportedVoltages.push(reader.double());
                    break;
                case /* google.protobuf.Struct specifications */ 22:
                    message.specifications = Struct.internalBinaryRead(reader, reader.uint32(), options, message.specifications);
                    break;
                case /* int32 power_efficiency */ 27:
                    message.powerEfficiency = reader.int32();
                    break;
                case /* string phase_type */ 28:
                    message.phaseType = reader.string();
                    break;
                case /* int32 zero_power_setpoints_allowed_per_session */ 29:
                    message.zeroPowerSetpointsAllowedPerSession = reader.int32();
                    break;
                case /* int64 efficiency_min_charge_power */ 30:
                    message.efficiencyMinChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 efficiency_max_charge_power */ 31:
                    message.efficiencyMaxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 strict_min_charge_power */ 32:
                    message.strictMinChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 max_charge_power */ 33:
                    message.maxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 max_discharge_power */ 34:
                    message.maxDischargePower = reader.int64().toBigInt();
                    break;
                case /* int64 strict_min_discharge_power */ 35:
                    message.strictMinDischargePower = reader.int64().toBigInt();
                    break;
                case /* int64 efficiency_min_discharge_power */ 36:
                    message.efficiencyMinDischargePower = reader.int64().toBigInt();
                    break;
                case /* int64 efficiency_max_discharge_power */ 37:
                    message.efficiencyMaxDischargePower = reader.int64().toBigInt();
                    break;
                case /* double charge_efficiency_at_min_percent */ 38:
                    message.chargeEfficiencyAtMinPercent = reader.double();
                    break;
                case /* double charge_efficiency_at_max_percent */ 39:
                    message.chargeEfficiencyAtMaxPercent = reader.double();
                    break;
                case /* double discharge_efficiency_at_min_percent */ 40:
                    message.dischargeEfficiencyAtMinPercent = reader.double();
                    break;
                case /* double discharge_efficiency_at_max_percent */ 41:
                    message.dischargeEfficiencyAtMaxPercent = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string manufacturer = 2; */
        if (message.manufacturer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.manufacturer);
        /* string model_name = 3; */
        if (message.modelName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.modelName);
        /* bool supports_sleep = 4; */
        if (message.supportsSleep !== false)
            writer.tag(4, WireType.Varint).bool(message.supportsSleep);
        /* devices.v1.ChargingRateUnit charging_rate_unit = 5; */
        if (message.chargingRateUnit !== 0)
            writer.tag(5, WireType.Varint).int32(message.chargingRateUnit);
        /* devices.v1.PowerSpecification power_spec = 6; */
        if (message.powerSpec)
            PowerSpecification.internalBinaryWrite(message.powerSpec, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool zero_power_setpoints_allowed_per_transaction = 9; */
        if (message.zeroPowerSetpointsAllowedPerTransaction !== false)
            writer.tag(9, WireType.Varint).bool(message.zeroPowerSetpointsAllowedPerTransaction);
        /* int64 standby_losses_w = 10; */
        if (message.standbyLossesW !== 0n)
            writer.tag(10, WireType.Varint).int64(message.standbyLossesW);
        /* double variable_losses_percent = 11; */
        if (message.variableLossesPercent !== 0)
            writer.tag(11, WireType.Bit64).double(message.variableLossesPercent);
        /* int32 phases = 12; */
        if (message.phases !== 0)
            writer.tag(12, WireType.Varint).int32(message.phases);
        /* devices.v1.CurrentType current_type = 13; */
        if (message.currentType !== 0)
            writer.tag(13, WireType.Varint).int32(message.currentType);
        /* string charging_command_interface = 14; */
        if (message.chargingCommandInterface !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.chargingCommandInterface);
        /* double peak_power_efficiency_percent = 15; */
        if (message.peakPowerEfficiencyPercent !== 0)
            writer.tag(15, WireType.Bit64).double(message.peakPowerEfficiencyPercent);
        /* devices.v1.Timestamps timestamps = 17; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.Evse evses = 18; */
        for (let i = 0; i < message.evses.length; i++)
            Evse.internalBinaryWrite(message.evses[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* int32 model_year = 19; */
        if (message.modelYear !== 0)
            writer.tag(19, WireType.Varint).int32(message.modelYear);
        /* repeated double supported_voltages = 21; */
        if (message.supportedVoltages.length) {
            writer.tag(21, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.supportedVoltages.length; i++)
                writer.double(message.supportedVoltages[i]);
            writer.join();
        }
        /* google.protobuf.Struct specifications = 22; */
        if (message.specifications)
            Struct.internalBinaryWrite(message.specifications, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* int32 power_efficiency = 27; */
        if (message.powerEfficiency !== 0)
            writer.tag(27, WireType.Varint).int32(message.powerEfficiency);
        /* string phase_type = 28; */
        if (message.phaseType !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.phaseType);
        /* int32 zero_power_setpoints_allowed_per_session = 29; */
        if (message.zeroPowerSetpointsAllowedPerSession !== 0)
            writer.tag(29, WireType.Varint).int32(message.zeroPowerSetpointsAllowedPerSession);
        /* int64 efficiency_min_charge_power = 30; */
        if (message.efficiencyMinChargePower !== 0n)
            writer.tag(30, WireType.Varint).int64(message.efficiencyMinChargePower);
        /* int64 efficiency_max_charge_power = 31; */
        if (message.efficiencyMaxChargePower !== 0n)
            writer.tag(31, WireType.Varint).int64(message.efficiencyMaxChargePower);
        /* int64 strict_min_charge_power = 32; */
        if (message.strictMinChargePower !== 0n)
            writer.tag(32, WireType.Varint).int64(message.strictMinChargePower);
        /* int64 max_charge_power = 33; */
        if (message.maxChargePower !== 0n)
            writer.tag(33, WireType.Varint).int64(message.maxChargePower);
        /* int64 max_discharge_power = 34; */
        if (message.maxDischargePower !== 0n)
            writer.tag(34, WireType.Varint).int64(message.maxDischargePower);
        /* int64 strict_min_discharge_power = 35; */
        if (message.strictMinDischargePower !== 0n)
            writer.tag(35, WireType.Varint).int64(message.strictMinDischargePower);
        /* int64 efficiency_min_discharge_power = 36; */
        if (message.efficiencyMinDischargePower !== 0n)
            writer.tag(36, WireType.Varint).int64(message.efficiencyMinDischargePower);
        /* int64 efficiency_max_discharge_power = 37; */
        if (message.efficiencyMaxDischargePower !== 0n)
            writer.tag(37, WireType.Varint).int64(message.efficiencyMaxDischargePower);
        /* double charge_efficiency_at_min_percent = 38; */
        if (message.chargeEfficiencyAtMinPercent !== 0)
            writer.tag(38, WireType.Bit64).double(message.chargeEfficiencyAtMinPercent);
        /* double charge_efficiency_at_max_percent = 39; */
        if (message.chargeEfficiencyAtMaxPercent !== 0)
            writer.tag(39, WireType.Bit64).double(message.chargeEfficiencyAtMaxPercent);
        /* double discharge_efficiency_at_min_percent = 40; */
        if (message.dischargeEfficiencyAtMinPercent !== 0)
            writer.tag(40, WireType.Bit64).double(message.dischargeEfficiencyAtMinPercent);
        /* double discharge_efficiency_at_max_percent = 41; */
        if (message.dischargeEfficiencyAtMaxPercent !== 0)
            writer.tag(41, WireType.Bit64).double(message.dischargeEfficiencyAtMaxPercent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.EvseModel
 */
export const EvseModel = new EvseModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Evse$Type extends MessageType {
    constructor() {
        super("devices.v1.Evse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "station_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "evse_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "permission_to_discharge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 11, name: "match_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "deployment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "device", kind: "message", T: () => Device },
            { no: 8, name: "model", kind: "message", T: () => EvseModel },
            { no: 9, name: "station", kind: "message", T: () => Station },
            { no: 10, name: "connectors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Connector },
            { no: 16, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.stationId = "";
        message.evseNumber = 0;
        message.permissionToDischarge = false;
        message.matchPhase = "";
        message.name = "";
        message.serialNumber = "";
        message.externalId = "";
        message.deploymentStatus = "";
        message.connectors = [];
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string station_id */ 3:
                    message.stationId = reader.string();
                    break;
                case /* int32 evse_number */ 4:
                    message.evseNumber = reader.int32();
                    break;
                case /* bool permission_to_discharge */ 5:
                    message.permissionToDischarge = reader.bool();
                    break;
                case /* devices.v1.Timestamps timestamps */ 6:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* string match_phase */ 11:
                    message.matchPhase = reader.string();
                    break;
                case /* string name */ 12:
                    message.name = reader.string();
                    break;
                case /* string serial_number */ 13:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 14:
                    message.externalId = reader.string();
                    break;
                case /* string deployment_status */ 15:
                    message.deploymentStatus = reader.string();
                    break;
                case /* devices.v1.Device device */ 7:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* devices.v1.EvseModel model */ 8:
                    message.model = EvseModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                case /* devices.v1.Station station */ 9:
                    message.station = Station.internalBinaryRead(reader, reader.uint32(), options, message.station);
                    break;
                case /* repeated devices.v1.Connector connectors */ 10:
                    message.connectors.push(Connector.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string model_id */ 16:
                    message.modelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string station_id = 3; */
        if (message.stationId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.stationId);
        /* int32 evse_number = 4; */
        if (message.evseNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.evseNumber);
        /* bool permission_to_discharge = 5; */
        if (message.permissionToDischarge !== false)
            writer.tag(5, WireType.Varint).bool(message.permissionToDischarge);
        /* devices.v1.Timestamps timestamps = 6; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Device device = 7; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.EvseModel model = 8; */
        if (message.model)
            EvseModel.internalBinaryWrite(message.model, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Station station = 9; */
        if (message.station)
            Station.internalBinaryWrite(message.station, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.Connector connectors = 10; */
        for (let i = 0; i < message.connectors.length; i++)
            Connector.internalBinaryWrite(message.connectors[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string match_phase = 11; */
        if (message.matchPhase !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.matchPhase);
        /* string name = 12; */
        if (message.name !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.name);
        /* string serial_number = 13; */
        if (message.serialNumber !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 14; */
        if (message.externalId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.externalId);
        /* string deployment_status = 15; */
        if (message.deploymentStatus !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.deploymentStatus);
        /* string model_id = 16; */
        if (message.modelId !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.modelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.Evse
 */
export const Evse = new Evse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorModel$Type extends MessageType {
    constructor() {
        super("devices.v1.ConnectorModel", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "connector_type", kind: "enum", T: () => ["devices.v1.ConnectorType", ConnectorType, "CONNECTOR_TYPE_"] },
            { no: 5, name: "power_spec", kind: "message", T: () => PowerSpecification },
            { no: 6, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 7, name: "connectors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Connector },
            { no: 9, name: "max_voltage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "max_rated_current", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "specifications", kind: "message", T: () => Struct },
            { no: 12, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "voltage_across_phases", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "voltage_across_pins_or_ln", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "connector_type_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "current_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 19, name: "max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.manufacturer = "";
        message.connectorType = 0;
        message.connectors = [];
        message.maxVoltage = 0;
        message.maxRatedCurrent = 0;
        message.name = "";
        message.voltageAcrossPhases = 0;
        message.voltageAcrossPinsOrLn = 0;
        message.connectorTypeDescription = "";
        message.currentType = "";
        message.maxChargePower = 0n;
        message.maxDischargePower = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string manufacturer */ 2:
                    message.manufacturer = reader.string();
                    break;
                case /* devices.v1.ConnectorType connector_type */ 4:
                    message.connectorType = reader.int32();
                    break;
                case /* devices.v1.PowerSpecification power_spec */ 5:
                    message.powerSpec = PowerSpecification.internalBinaryRead(reader, reader.uint32(), options, message.powerSpec);
                    break;
                case /* devices.v1.Timestamps timestamps */ 6:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* repeated devices.v1.Connector connectors */ 7:
                    message.connectors.push(Connector.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* double max_voltage */ 9:
                    message.maxVoltage = reader.double();
                    break;
                case /* double max_rated_current */ 10:
                    message.maxRatedCurrent = reader.double();
                    break;
                case /* google.protobuf.Struct specifications */ 11:
                    message.specifications = Struct.internalBinaryRead(reader, reader.uint32(), options, message.specifications);
                    break;
                case /* string name */ 12:
                    message.name = reader.string();
                    break;
                case /* double voltage_across_phases */ 14:
                    message.voltageAcrossPhases = reader.double();
                    break;
                case /* double voltage_across_pins_or_ln */ 15:
                    message.voltageAcrossPinsOrLn = reader.double();
                    break;
                case /* string connector_type_description */ 16:
                    message.connectorTypeDescription = reader.string();
                    break;
                case /* string current_type */ 17:
                    message.currentType = reader.string();
                    break;
                case /* int64 max_charge_power */ 18:
                    message.maxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 max_discharge_power */ 19:
                    message.maxDischargePower = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string manufacturer = 2; */
        if (message.manufacturer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.manufacturer);
        /* devices.v1.ConnectorType connector_type = 4; */
        if (message.connectorType !== 0)
            writer.tag(4, WireType.Varint).int32(message.connectorType);
        /* devices.v1.PowerSpecification power_spec = 5; */
        if (message.powerSpec)
            PowerSpecification.internalBinaryWrite(message.powerSpec, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Timestamps timestamps = 6; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.Connector connectors = 7; */
        for (let i = 0; i < message.connectors.length; i++)
            Connector.internalBinaryWrite(message.connectors[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* double max_voltage = 9; */
        if (message.maxVoltage !== 0)
            writer.tag(9, WireType.Bit64).double(message.maxVoltage);
        /* double max_rated_current = 10; */
        if (message.maxRatedCurrent !== 0)
            writer.tag(10, WireType.Bit64).double(message.maxRatedCurrent);
        /* google.protobuf.Struct specifications = 11; */
        if (message.specifications)
            Struct.internalBinaryWrite(message.specifications, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string name = 12; */
        if (message.name !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.name);
        /* double voltage_across_phases = 14; */
        if (message.voltageAcrossPhases !== 0)
            writer.tag(14, WireType.Bit64).double(message.voltageAcrossPhases);
        /* double voltage_across_pins_or_ln = 15; */
        if (message.voltageAcrossPinsOrLn !== 0)
            writer.tag(15, WireType.Bit64).double(message.voltageAcrossPinsOrLn);
        /* string connector_type_description = 16; */
        if (message.connectorTypeDescription !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.connectorTypeDescription);
        /* string current_type = 17; */
        if (message.currentType !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.currentType);
        /* int64 max_charge_power = 18; */
        if (message.maxChargePower !== 0n)
            writer.tag(18, WireType.Varint).int64(message.maxChargePower);
        /* int64 max_discharge_power = 19; */
        if (message.maxDischargePower !== 0n)
            writer.tag(19, WireType.Varint).int64(message.maxDischargePower);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ConnectorModel
 */
export const ConnectorModel = new ConnectorModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Connector$Type extends MessageType {
    constructor() {
        super("devices.v1.Connector", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "evse_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "connector_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 9, name: "permission_to_discharge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "match_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "deployment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "device", kind: "message", T: () => Device },
            { no: 7, name: "model", kind: "message", T: () => ConnectorModel },
            { no: 8, name: "evse", kind: "message", T: () => Evse },
            { no: 15, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.evseId = "";
        message.connectorNumber = 0;
        message.permissionToDischarge = false;
        message.matchPhase = "";
        message.name = "";
        message.serialNumber = "";
        message.externalId = "";
        message.deploymentStatus = "";
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string evse_id */ 3:
                    message.evseId = reader.string();
                    break;
                case /* int32 connector_number */ 4:
                    message.connectorNumber = reader.int32();
                    break;
                case /* devices.v1.Timestamps timestamps */ 5:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* bool permission_to_discharge */ 9:
                    message.permissionToDischarge = reader.bool();
                    break;
                case /* string match_phase */ 10:
                    message.matchPhase = reader.string();
                    break;
                case /* string name */ 11:
                    message.name = reader.string();
                    break;
                case /* string serial_number */ 12:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 13:
                    message.externalId = reader.string();
                    break;
                case /* string deployment_status */ 14:
                    message.deploymentStatus = reader.string();
                    break;
                case /* devices.v1.Device device */ 6:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* devices.v1.ConnectorModel model */ 7:
                    message.model = ConnectorModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                case /* devices.v1.Evse evse */ 8:
                    message.evse = Evse.internalBinaryRead(reader, reader.uint32(), options, message.evse);
                    break;
                case /* string model_id */ 15:
                    message.modelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string evse_id = 3; */
        if (message.evseId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.evseId);
        /* int32 connector_number = 4; */
        if (message.connectorNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.connectorNumber);
        /* devices.v1.Timestamps timestamps = 5; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Device device = 6; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.ConnectorModel model = 7; */
        if (message.model)
            ConnectorModel.internalBinaryWrite(message.model, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Evse evse = 8; */
        if (message.evse)
            Evse.internalBinaryWrite(message.evse, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool permission_to_discharge = 9; */
        if (message.permissionToDischarge !== false)
            writer.tag(9, WireType.Varint).bool(message.permissionToDischarge);
        /* string match_phase = 10; */
        if (message.matchPhase !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.matchPhase);
        /* string name = 11; */
        if (message.name !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.name);
        /* string serial_number = 12; */
        if (message.serialNumber !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 13; */
        if (message.externalId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.externalId);
        /* string deployment_status = 14; */
        if (message.deploymentStatus !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.deploymentStatus);
        /* string model_id = 15; */
        if (message.modelId !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.modelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.Connector
 */
export const Connector = new Connector$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StationBatteryModel$Type extends MessageType {
    constructor() {
        super("devices.v1.StationBatteryModel", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "communication_protocol_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "communication_interval", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "dispatch_error_allowance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "dispatch_error_allowed_interval_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "sleep_dispatch_error_allowance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "max_soc_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "min_soc_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 15, name: "protocol", kind: "message", T: () => DeviceCommunicationProtocol },
            { no: 17, name: "model_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "nominal_voltage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 19, name: "specifications", kind: "message", T: () => Struct },
            { no: 20, name: "energy_capacity", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 21, name: "max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 22, name: "max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 23, name: "standby_losses_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 24, name: "variable_losses_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 25, name: "efficiency_min_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 26, name: "efficiency_max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 27, name: "efficiency_min_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 28, name: "efficiency_max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 29, name: "charge_efficiency_at_min_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 30, name: "charge_efficiency_at_max_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 31, name: "discharge_efficiency_at_min_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 32, name: "discharge_efficiency_at_max_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 33, name: "wear_cost_usd_per_kwh", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.manufacturer = "";
        message.modelName = "";
        message.communicationProtocolId = "";
        message.communicationInterval = 0;
        message.dispatchErrorAllowance = 0;
        message.dispatchErrorAllowedIntervalSeconds = 0;
        message.sleepDispatchErrorAllowance = 0;
        message.maxSocPercent = 0;
        message.minSocPercent = 0;
        message.modelYear = 0;
        message.nominalVoltage = 0;
        message.energyCapacity = 0n;
        message.maxChargePower = 0n;
        message.maxDischargePower = 0n;
        message.standbyLossesW = 0n;
        message.variableLossesPercent = 0;
        message.efficiencyMinChargePower = 0n;
        message.efficiencyMaxChargePower = 0n;
        message.efficiencyMinDischargePower = 0n;
        message.efficiencyMaxDischargePower = 0n;
        message.chargeEfficiencyAtMinPercent = 0;
        message.chargeEfficiencyAtMaxPercent = 0;
        message.dischargeEfficiencyAtMinPercent = 0;
        message.dischargeEfficiencyAtMaxPercent = 0;
        message.wearCostUsdPerKwh = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string manufacturer */ 2:
                    message.manufacturer = reader.string();
                    break;
                case /* string model_name */ 3:
                    message.modelName = reader.string();
                    break;
                case /* string communication_protocol_id */ 4:
                    message.communicationProtocolId = reader.string();
                    break;
                case /* int32 communication_interval */ 5:
                    message.communicationInterval = reader.int32();
                    break;
                case /* int32 dispatch_error_allowance */ 6:
                    message.dispatchErrorAllowance = reader.int32();
                    break;
                case /* int32 dispatch_error_allowed_interval_seconds */ 7:
                    message.dispatchErrorAllowedIntervalSeconds = reader.int32();
                    break;
                case /* int32 sleep_dispatch_error_allowance */ 8:
                    message.sleepDispatchErrorAllowance = reader.int32();
                    break;
                case /* double max_soc_percent */ 12:
                    message.maxSocPercent = reader.double();
                    break;
                case /* double min_soc_percent */ 13:
                    message.minSocPercent = reader.double();
                    break;
                case /* devices.v1.Timestamps timestamps */ 14:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* devices.v1.DeviceCommunicationProtocol protocol */ 15:
                    message.protocol = DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options, message.protocol);
                    break;
                case /* int32 model_year */ 17:
                    message.modelYear = reader.int32();
                    break;
                case /* double nominal_voltage */ 18:
                    message.nominalVoltage = reader.double();
                    break;
                case /* google.protobuf.Struct specifications */ 19:
                    message.specifications = Struct.internalBinaryRead(reader, reader.uint32(), options, message.specifications);
                    break;
                case /* int64 energy_capacity */ 20:
                    message.energyCapacity = reader.int64().toBigInt();
                    break;
                case /* int64 max_charge_power */ 21:
                    message.maxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 max_discharge_power */ 22:
                    message.maxDischargePower = reader.int64().toBigInt();
                    break;
                case /* int64 standby_losses_w */ 23:
                    message.standbyLossesW = reader.int64().toBigInt();
                    break;
                case /* double variable_losses_percent */ 24:
                    message.variableLossesPercent = reader.double();
                    break;
                case /* int64 efficiency_min_charge_power */ 25:
                    message.efficiencyMinChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 efficiency_max_charge_power */ 26:
                    message.efficiencyMaxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 efficiency_min_discharge_power */ 27:
                    message.efficiencyMinDischargePower = reader.int64().toBigInt();
                    break;
                case /* int64 efficiency_max_discharge_power */ 28:
                    message.efficiencyMaxDischargePower = reader.int64().toBigInt();
                    break;
                case /* double charge_efficiency_at_min_percent */ 29:
                    message.chargeEfficiencyAtMinPercent = reader.double();
                    break;
                case /* double charge_efficiency_at_max_percent */ 30:
                    message.chargeEfficiencyAtMaxPercent = reader.double();
                    break;
                case /* double discharge_efficiency_at_min_percent */ 31:
                    message.dischargeEfficiencyAtMinPercent = reader.double();
                    break;
                case /* double discharge_efficiency_at_max_percent */ 32:
                    message.dischargeEfficiencyAtMaxPercent = reader.double();
                    break;
                case /* double wear_cost_usd_per_kwh */ 33:
                    message.wearCostUsdPerKwh = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string manufacturer = 2; */
        if (message.manufacturer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.manufacturer);
        /* string model_name = 3; */
        if (message.modelName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.modelName);
        /* string communication_protocol_id = 4; */
        if (message.communicationProtocolId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.communicationProtocolId);
        /* int32 communication_interval = 5; */
        if (message.communicationInterval !== 0)
            writer.tag(5, WireType.Varint).int32(message.communicationInterval);
        /* int32 dispatch_error_allowance = 6; */
        if (message.dispatchErrorAllowance !== 0)
            writer.tag(6, WireType.Varint).int32(message.dispatchErrorAllowance);
        /* int32 dispatch_error_allowed_interval_seconds = 7; */
        if (message.dispatchErrorAllowedIntervalSeconds !== 0)
            writer.tag(7, WireType.Varint).int32(message.dispatchErrorAllowedIntervalSeconds);
        /* int32 sleep_dispatch_error_allowance = 8; */
        if (message.sleepDispatchErrorAllowance !== 0)
            writer.tag(8, WireType.Varint).int32(message.sleepDispatchErrorAllowance);
        /* double max_soc_percent = 12; */
        if (message.maxSocPercent !== 0)
            writer.tag(12, WireType.Bit64).double(message.maxSocPercent);
        /* double min_soc_percent = 13; */
        if (message.minSocPercent !== 0)
            writer.tag(13, WireType.Bit64).double(message.minSocPercent);
        /* devices.v1.Timestamps timestamps = 14; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.DeviceCommunicationProtocol protocol = 15; */
        if (message.protocol)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocol, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* int32 model_year = 17; */
        if (message.modelYear !== 0)
            writer.tag(17, WireType.Varint).int32(message.modelYear);
        /* double nominal_voltage = 18; */
        if (message.nominalVoltage !== 0)
            writer.tag(18, WireType.Bit64).double(message.nominalVoltage);
        /* google.protobuf.Struct specifications = 19; */
        if (message.specifications)
            Struct.internalBinaryWrite(message.specifications, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* int64 energy_capacity = 20; */
        if (message.energyCapacity !== 0n)
            writer.tag(20, WireType.Varint).int64(message.energyCapacity);
        /* int64 max_charge_power = 21; */
        if (message.maxChargePower !== 0n)
            writer.tag(21, WireType.Varint).int64(message.maxChargePower);
        /* int64 max_discharge_power = 22; */
        if (message.maxDischargePower !== 0n)
            writer.tag(22, WireType.Varint).int64(message.maxDischargePower);
        /* int64 standby_losses_w = 23; */
        if (message.standbyLossesW !== 0n)
            writer.tag(23, WireType.Varint).int64(message.standbyLossesW);
        /* double variable_losses_percent = 24; */
        if (message.variableLossesPercent !== 0)
            writer.tag(24, WireType.Bit64).double(message.variableLossesPercent);
        /* int64 efficiency_min_charge_power = 25; */
        if (message.efficiencyMinChargePower !== 0n)
            writer.tag(25, WireType.Varint).int64(message.efficiencyMinChargePower);
        /* int64 efficiency_max_charge_power = 26; */
        if (message.efficiencyMaxChargePower !== 0n)
            writer.tag(26, WireType.Varint).int64(message.efficiencyMaxChargePower);
        /* int64 efficiency_min_discharge_power = 27; */
        if (message.efficiencyMinDischargePower !== 0n)
            writer.tag(27, WireType.Varint).int64(message.efficiencyMinDischargePower);
        /* int64 efficiency_max_discharge_power = 28; */
        if (message.efficiencyMaxDischargePower !== 0n)
            writer.tag(28, WireType.Varint).int64(message.efficiencyMaxDischargePower);
        /* double charge_efficiency_at_min_percent = 29; */
        if (message.chargeEfficiencyAtMinPercent !== 0)
            writer.tag(29, WireType.Bit64).double(message.chargeEfficiencyAtMinPercent);
        /* double charge_efficiency_at_max_percent = 30; */
        if (message.chargeEfficiencyAtMaxPercent !== 0)
            writer.tag(30, WireType.Bit64).double(message.chargeEfficiencyAtMaxPercent);
        /* double discharge_efficiency_at_min_percent = 31; */
        if (message.dischargeEfficiencyAtMinPercent !== 0)
            writer.tag(31, WireType.Bit64).double(message.dischargeEfficiencyAtMinPercent);
        /* double discharge_efficiency_at_max_percent = 32; */
        if (message.dischargeEfficiencyAtMaxPercent !== 0)
            writer.tag(32, WireType.Bit64).double(message.dischargeEfficiencyAtMaxPercent);
        /* double wear_cost_usd_per_kwh = 33; */
        if (message.wearCostUsdPerKwh !== 0)
            writer.tag(33, WireType.Bit64).double(message.wearCostUsdPerKwh);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.StationBatteryModel
 */
export const StationBatteryModel = new StationBatteryModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StationaryBattery$Type extends MessageType {
    constructor() {
        super("devices.v1.StationaryBattery", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "deployment_status", kind: "enum", T: () => ["devices.v1.DeploymentStatus", DeploymentStatus, "DEPLOYMENT_STATUS_"] },
            { no: 4, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 9, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "usable_capacity_wh", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "capacity_measured_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "device", kind: "message", T: () => Device },
            { no: 7, name: "model", kind: "message", T: () => StationBatteryModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.deploymentStatus = 0;
        message.siteId = "";
        message.name = "";
        message.serialNumber = "";
        message.externalId = "";
        message.displayName = "";
        message.modelId = "";
        message.capacityMeasuredAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.DeploymentStatus deployment_status */ 3:
                    message.deploymentStatus = reader.int32();
                    break;
                case /* string site_id */ 4:
                    message.siteId = reader.string();
                    break;
                case /* devices.v1.Timestamps timestamps */ 5:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* string name */ 9:
                    message.name = reader.string();
                    break;
                case /* string serial_number */ 10:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 11:
                    message.externalId = reader.string();
                    break;
                case /* string display_name */ 12:
                    message.displayName = reader.string();
                    break;
                case /* string model_id */ 13:
                    message.modelId = reader.string();
                    break;
                case /* optional double usable_capacity_wh */ 14:
                    message.usableCapacityWh = reader.double();
                    break;
                case /* int64 capacity_measured_at */ 15:
                    message.capacityMeasuredAt = reader.int64().toBigInt();
                    break;
                case /* devices.v1.Device device */ 6:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* devices.v1.StationBatteryModel model */ 7:
                    message.model = StationBatteryModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.DeploymentStatus deployment_status = 3; */
        if (message.deploymentStatus !== 0)
            writer.tag(3, WireType.Varint).int32(message.deploymentStatus);
        /* string site_id = 4; */
        if (message.siteId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.siteId);
        /* devices.v1.Timestamps timestamps = 5; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Device device = 6; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.StationBatteryModel model = 7; */
        if (message.model)
            StationBatteryModel.internalBinaryWrite(message.model, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string name = 9; */
        if (message.name !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.name);
        /* string serial_number = 10; */
        if (message.serialNumber !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 11; */
        if (message.externalId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.externalId);
        /* string display_name = 12; */
        if (message.displayName !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.displayName);
        /* string model_id = 13; */
        if (message.modelId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.modelId);
        /* optional double usable_capacity_wh = 14; */
        if (message.usableCapacityWh !== undefined)
            writer.tag(14, WireType.Bit64).double(message.usableCapacityWh);
        /* int64 capacity_measured_at = 15; */
        if (message.capacityMeasuredAt !== 0n)
            writer.tag(15, WireType.Varint).int64(message.capacityMeasuredAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.StationaryBattery
 */
export const StationaryBattery = new StationaryBattery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceErrorType$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceErrorType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "criticality", kind: "enum", T: () => ["devices.v1.CriticalityLevel", CriticalityLevel, "CRITICALITY_LEVEL_"] },
            { no: 7, name: "resolution_steps", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "timestamps", kind: "message", T: () => Timestamps }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.modelId = "";
        message.errorCode = "";
        message.reason = "";
        message.criticality = 0;
        message.resolutionSteps = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                case /* string error_code */ 3:
                    message.errorCode = reader.string();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* devices.v1.CriticalityLevel criticality */ 6:
                    message.criticality = reader.int32();
                    break;
                case /* string resolution_steps */ 7:
                    message.resolutionSteps = reader.string();
                    break;
                case /* devices.v1.Timestamps timestamps */ 8:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        /* string error_code = 3; */
        if (message.errorCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorCode);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* devices.v1.CriticalityLevel criticality = 6; */
        if (message.criticality !== 0)
            writer.tag(6, WireType.Varint).int32(message.criticality);
        /* string resolution_steps = 7; */
        if (message.resolutionSteps !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.resolutionSteps);
        /* devices.v1.Timestamps timestamps = 8; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceErrorType
 */
export const DeviceErrorType = new DeviceErrorType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceError$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceError", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "criticality", kind: "enum", T: () => ["devices.v1.CriticalityLevel", CriticalityLevel, "CRITICALITY_LEVEL_"] },
            { no: 6, name: "details", kind: "message", T: () => Struct },
            { no: 7, name: "is_resolved", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "resolution_details", kind: "message", T: () => Struct },
            { no: 9, name: "created_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "resolved_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "device", kind: "message", T: () => Device },
            { no: 13, name: "error_type", kind: "message", T: () => DeviceErrorType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.deviceId = "";
        message.modelId = "";
        message.errorCode = "";
        message.criticality = 0;
        message.isResolved = false;
        message.createdAt = 0n;
        message.timestamp = 0n;
        message.resolvedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string device_id */ 2:
                    message.deviceId = reader.string();
                    break;
                case /* string model_id */ 3:
                    message.modelId = reader.string();
                    break;
                case /* string error_code */ 4:
                    message.errorCode = reader.string();
                    break;
                case /* devices.v1.CriticalityLevel criticality */ 5:
                    message.criticality = reader.int32();
                    break;
                case /* google.protobuf.Struct details */ 6:
                    message.details = Struct.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                case /* bool is_resolved */ 7:
                    message.isResolved = reader.bool();
                    break;
                case /* google.protobuf.Struct resolution_details */ 8:
                    message.resolutionDetails = Struct.internalBinaryRead(reader, reader.uint32(), options, message.resolutionDetails);
                    break;
                case /* int64 created_at */ 9:
                    message.createdAt = reader.int64().toBigInt();
                    break;
                case /* int64 timestamp */ 10:
                    message.timestamp = reader.int64().toBigInt();
                    break;
                case /* int64 resolved_at */ 11:
                    message.resolvedAt = reader.int64().toBigInt();
                    break;
                case /* devices.v1.Device device */ 12:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* devices.v1.DeviceErrorType error_type */ 13:
                    message.errorType = DeviceErrorType.internalBinaryRead(reader, reader.uint32(), options, message.errorType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string device_id = 2; */
        if (message.deviceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceId);
        /* string model_id = 3; */
        if (message.modelId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.modelId);
        /* string error_code = 4; */
        if (message.errorCode !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.errorCode);
        /* devices.v1.CriticalityLevel criticality = 5; */
        if (message.criticality !== 0)
            writer.tag(5, WireType.Varint).int32(message.criticality);
        /* google.protobuf.Struct details = 6; */
        if (message.details)
            Struct.internalBinaryWrite(message.details, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_resolved = 7; */
        if (message.isResolved !== false)
            writer.tag(7, WireType.Varint).bool(message.isResolved);
        /* google.protobuf.Struct resolution_details = 8; */
        if (message.resolutionDetails)
            Struct.internalBinaryWrite(message.resolutionDetails, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* int64 created_at = 9; */
        if (message.createdAt !== 0n)
            writer.tag(9, WireType.Varint).int64(message.createdAt);
        /* int64 timestamp = 10; */
        if (message.timestamp !== 0n)
            writer.tag(10, WireType.Varint).int64(message.timestamp);
        /* int64 resolved_at = 11; */
        if (message.resolvedAt !== 0n)
            writer.tag(11, WireType.Varint).int64(message.resolvedAt);
        /* devices.v1.Device device = 12; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.DeviceErrorType error_type = 13; */
        if (message.errorType)
            DeviceErrorType.internalBinaryWrite(message.errorType, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceError
 */
export const DeviceError = new DeviceError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ControlSignalType$Type extends MessageType {
    constructor() {
        super("devices.v1.ControlSignalType", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "min_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "max_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.deviceModelId = "";
        message.description = "";
        message.unit = "";
        message.minValue = 0;
        message.maxValue = 0;
        message.createdAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string device_model_id */ 2:
                    message.deviceModelId = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string unit */ 4:
                    message.unit = reader.string();
                    break;
                case /* double min_value */ 5:
                    message.minValue = reader.double();
                    break;
                case /* double max_value */ 6:
                    message.maxValue = reader.double();
                    break;
                case /* int64 created_at */ 7:
                    message.createdAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string device_model_id = 2; */
        if (message.deviceModelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceModelId);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string unit = 4; */
        if (message.unit !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.unit);
        /* double min_value = 5; */
        if (message.minValue !== 0)
            writer.tag(5, WireType.Bit64).double(message.minValue);
        /* double max_value = 6; */
        if (message.maxValue !== 0)
            writer.tag(6, WireType.Bit64).double(message.maxValue);
        /* int64 created_at = 7; */
        if (message.createdAt !== 0n)
            writer.tag(7, WireType.Varint).int64(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ControlSignalType
 */
export const ControlSignalType = new ControlSignalType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MicrogridControllerModel$Type extends MessageType {
    constructor() {
        super("devices.v1.MicrogridControllerModel", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "communication_protocol_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "communication_interval", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "dispatch_error_allowance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "dispatch_error_allowed_interval_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "sleep_dispatch_error_allowance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 9, name: "protocol", kind: "message", T: () => DeviceCommunicationProtocol },
            { no: 10, name: "controllers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MicrogridController }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.manufacturer = "";
        message.communicationProtocolId = "";
        message.communicationInterval = 0;
        message.dispatchErrorAllowance = 0;
        message.dispatchErrorAllowedIntervalSeconds = 0;
        message.sleepDispatchErrorAllowance = 0;
        message.controllers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string manufacturer */ 2:
                    message.manufacturer = reader.string();
                    break;
                case /* string communication_protocol_id */ 3:
                    message.communicationProtocolId = reader.string();
                    break;
                case /* int32 communication_interval */ 4:
                    message.communicationInterval = reader.int32();
                    break;
                case /* int32 dispatch_error_allowance */ 5:
                    message.dispatchErrorAllowance = reader.int32();
                    break;
                case /* int32 dispatch_error_allowed_interval_seconds */ 6:
                    message.dispatchErrorAllowedIntervalSeconds = reader.int32();
                    break;
                case /* int32 sleep_dispatch_error_allowance */ 7:
                    message.sleepDispatchErrorAllowance = reader.int32();
                    break;
                case /* devices.v1.Timestamps timestamps */ 8:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* devices.v1.DeviceCommunicationProtocol protocol */ 9:
                    message.protocol = DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options, message.protocol);
                    break;
                case /* repeated devices.v1.MicrogridController controllers */ 10:
                    message.controllers.push(MicrogridController.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string manufacturer = 2; */
        if (message.manufacturer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.manufacturer);
        /* string communication_protocol_id = 3; */
        if (message.communicationProtocolId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.communicationProtocolId);
        /* int32 communication_interval = 4; */
        if (message.communicationInterval !== 0)
            writer.tag(4, WireType.Varint).int32(message.communicationInterval);
        /* int32 dispatch_error_allowance = 5; */
        if (message.dispatchErrorAllowance !== 0)
            writer.tag(5, WireType.Varint).int32(message.dispatchErrorAllowance);
        /* int32 dispatch_error_allowed_interval_seconds = 6; */
        if (message.dispatchErrorAllowedIntervalSeconds !== 0)
            writer.tag(6, WireType.Varint).int32(message.dispatchErrorAllowedIntervalSeconds);
        /* int32 sleep_dispatch_error_allowance = 7; */
        if (message.sleepDispatchErrorAllowance !== 0)
            writer.tag(7, WireType.Varint).int32(message.sleepDispatchErrorAllowance);
        /* devices.v1.Timestamps timestamps = 8; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.DeviceCommunicationProtocol protocol = 9; */
        if (message.protocol)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocol, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.MicrogridController controllers = 10; */
        for (let i = 0; i < message.controllers.length; i++)
            MicrogridController.internalBinaryWrite(message.controllers[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.MicrogridControllerModel
 */
export const MicrogridControllerModel = new MicrogridControllerModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MicrogridController$Type extends MessageType {
    constructor() {
        super("devices.v1.MicrogridController", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 7, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "deployment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "device", kind: "message", T: () => Device },
            { no: 5, name: "model", kind: "message", T: () => MicrogridControllerModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.modelId = "";
        message.siteId = "";
        message.name = "";
        message.serialNumber = "";
        message.externalId = "";
        message.deploymentStatus = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                case /* string site_id */ 3:
                    message.siteId = reader.string();
                    break;
                case /* devices.v1.Timestamps timestamps */ 6:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* string name */ 7:
                    message.name = reader.string();
                    break;
                case /* string serial_number */ 8:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 9:
                    message.externalId = reader.string();
                    break;
                case /* string deployment_status */ 10:
                    message.deploymentStatus = reader.string();
                    break;
                case /* devices.v1.Device device */ 4:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* devices.v1.MicrogridControllerModel model */ 5:
                    message.model = MicrogridControllerModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        /* string site_id = 3; */
        if (message.siteId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.siteId);
        /* devices.v1.Device device = 4; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.MicrogridControllerModel model = 5; */
        if (message.model)
            MicrogridControllerModel.internalBinaryWrite(message.model, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Timestamps timestamps = 6; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string name = 7; */
        if (message.name !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.name);
        /* string serial_number = 8; */
        if (message.serialNumber !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 9; */
        if (message.externalId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.externalId);
        /* string deployment_status = 10; */
        if (message.deploymentStatus !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.deploymentStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.MicrogridController
 */
export const MicrogridController = new MicrogridController$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceDefaultProfilePeriod$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceDefaultProfilePeriod", [
            { no: 1, name: "start_period_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "limit_charge_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "limit_discharge_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "number_phases", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "desired_mode", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.startPeriodSeconds = 0;
        message.limitChargeW = 0n;
        message.limitDischargeW = 0n;
        message.numberPhases = 0;
        message.desiredMode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 start_period_seconds */ 1:
                    message.startPeriodSeconds = reader.int32();
                    break;
                case /* int64 limit_charge_w */ 2:
                    message.limitChargeW = reader.int64().toBigInt();
                    break;
                case /* int64 limit_discharge_w */ 3:
                    message.limitDischargeW = reader.int64().toBigInt();
                    break;
                case /* int32 number_phases */ 4:
                    message.numberPhases = reader.int32();
                    break;
                case /* string desired_mode */ 5:
                    message.desiredMode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 start_period_seconds = 1; */
        if (message.startPeriodSeconds !== 0)
            writer.tag(1, WireType.Varint).int32(message.startPeriodSeconds);
        /* int64 limit_charge_w = 2; */
        if (message.limitChargeW !== 0n)
            writer.tag(2, WireType.Varint).int64(message.limitChargeW);
        /* int64 limit_discharge_w = 3; */
        if (message.limitDischargeW !== 0n)
            writer.tag(3, WireType.Varint).int64(message.limitDischargeW);
        /* int32 number_phases = 4; */
        if (message.numberPhases !== 0)
            writer.tag(4, WireType.Varint).int32(message.numberPhases);
        /* string desired_mode = 5; */
        if (message.desiredMode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.desiredMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceDefaultProfilePeriod
 */
export const DeviceDefaultProfilePeriod = new DeviceDefaultProfilePeriod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceDefaultProfile$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceDefaultProfile", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "profile_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "recurrency_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "start_schedule", kind: "message", T: () => Timestamp },
            { no: 6, name: "schedule_periods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceDefaultProfilePeriod },
            { no: 7, name: "peak_charge_power_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "peak_discharge_power_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "connector_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "updated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "created_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.deviceId = "";
        message.profileKind = "";
        message.recurrencyKind = "";
        message.schedulePeriods = [];
        message.peakChargePowerW = 0n;
        message.peakDischargePowerW = 0n;
        message.connectorId = 0;
        message.updatedBy = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string device_id */ 2:
                    message.deviceId = reader.string();
                    break;
                case /* string profile_kind */ 3:
                    message.profileKind = reader.string();
                    break;
                case /* string recurrency_kind */ 4:
                    message.recurrencyKind = reader.string();
                    break;
                case /* google.protobuf.Timestamp start_schedule */ 5:
                    message.startSchedule = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startSchedule);
                    break;
                case /* repeated devices.v1.DeviceDefaultProfilePeriod schedule_periods */ 6:
                    message.schedulePeriods.push(DeviceDefaultProfilePeriod.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 peak_charge_power_w */ 7:
                    message.peakChargePowerW = reader.int64().toBigInt();
                    break;
                case /* int64 peak_discharge_power_w */ 8:
                    message.peakDischargePowerW = reader.int64().toBigInt();
                    break;
                case /* int32 connector_id */ 9:
                    message.connectorId = reader.int32();
                    break;
                case /* string updated_by */ 10:
                    message.updatedBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp created_at */ 12:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string device_id = 2; */
        if (message.deviceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceId);
        /* string profile_kind = 3; */
        if (message.profileKind !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.profileKind);
        /* string recurrency_kind = 4; */
        if (message.recurrencyKind !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.recurrencyKind);
        /* google.protobuf.Timestamp start_schedule = 5; */
        if (message.startSchedule)
            Timestamp.internalBinaryWrite(message.startSchedule, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated devices.v1.DeviceDefaultProfilePeriod schedule_periods = 6; */
        for (let i = 0; i < message.schedulePeriods.length; i++)
            DeviceDefaultProfilePeriod.internalBinaryWrite(message.schedulePeriods[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int64 peak_charge_power_w = 7; */
        if (message.peakChargePowerW !== 0n)
            writer.tag(7, WireType.Varint).int64(message.peakChargePowerW);
        /* int64 peak_discharge_power_w = 8; */
        if (message.peakDischargePowerW !== 0n)
            writer.tag(8, WireType.Varint).int64(message.peakDischargePowerW);
        /* int32 connector_id = 9; */
        if (message.connectorId !== 0)
            writer.tag(9, WireType.Varint).int32(message.connectorId);
        /* string updated_by = 10; */
        if (message.updatedBy !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.updatedBy);
        /* google.protobuf.Timestamp updated_at = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 12; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceDefaultProfile
 */
export const DeviceDefaultProfile = new DeviceDefaultProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceDefaultProfileHistoryEntry$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceDefaultProfileHistoryEntry", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "action", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "recurrency_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "schedule_periods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceDefaultProfilePeriod },
            { no: 7, name: "peak_charge_power_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "peak_discharge_power_w", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "connector_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "changed_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "changed_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.deviceId = "";
        message.action = "";
        message.profileKind = "";
        message.recurrencyKind = "";
        message.schedulePeriods = [];
        message.peakChargePowerW = 0n;
        message.peakDischargePowerW = 0n;
        message.connectorId = 0;
        message.changedBy = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string device_id */ 2:
                    message.deviceId = reader.string();
                    break;
                case /* string action */ 3:
                    message.action = reader.string();
                    break;
                case /* string profile_kind */ 4:
                    message.profileKind = reader.string();
                    break;
                case /* string recurrency_kind */ 5:
                    message.recurrencyKind = reader.string();
                    break;
                case /* repeated devices.v1.DeviceDefaultProfilePeriod schedule_periods */ 6:
                    message.schedulePeriods.push(DeviceDefaultProfilePeriod.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 peak_charge_power_w */ 7:
                    message.peakChargePowerW = reader.int64().toBigInt();
                    break;
                case /* int64 peak_discharge_power_w */ 8:
                    message.peakDischargePowerW = reader.int64().toBigInt();
                    break;
                case /* int32 connector_id */ 9:
                    message.connectorId = reader.int32();
                    break;
                case /* string changed_by */ 10:
                    message.changedBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp changed_at */ 11:
                    message.changedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.changedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string device_id = 2; */
        if (message.deviceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceId);
        /* string action = 3; */
        if (message.action !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.action);
        /* string profile_kind = 4; */
        if (message.profileKind !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.profileKind);
        /* string recurrency_kind = 5; */
        if (message.recurrencyKind !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.recurrencyKind);
        /* repeated devices.v1.DeviceDefaultProfilePeriod schedule_periods = 6; */
        for (let i = 0; i < message.schedulePeriods.length; i++)
            DeviceDefaultProfilePeriod.internalBinaryWrite(message.schedulePeriods[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int64 peak_charge_power_w = 7; */
        if (message.peakChargePowerW !== 0n)
            writer.tag(7, WireType.Varint).int64(message.peakChargePowerW);
        /* int64 peak_discharge_power_w = 8; */
        if (message.peakDischargePowerW !== 0n)
            writer.tag(8, WireType.Varint).int64(message.peakDischargePowerW);
        /* int32 connector_id = 9; */
        if (message.connectorId !== 0)
            writer.tag(9, WireType.Varint).int32(message.connectorId);
        /* string changed_by = 10; */
        if (message.changedBy !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.changedBy);
        /* google.protobuf.Timestamp changed_at = 11; */
        if (message.changedAt)
            Timestamp.internalBinaryWrite(message.changedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceDefaultProfileHistoryEntry
 */
export const DeviceDefaultProfileHistoryEntry = new DeviceDefaultProfileHistoryEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceConfiguredPowerLimits$Type extends MessageType {
    constructor() {
        super("devices.v1.DeviceConfiguredPowerLimits", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 7, name: "device", kind: "message", T: () => Device },
            { no: 8, name: "offline_max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "offline_max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "online_max_charge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "online_max_discharge_power", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.offlineMaxChargePower = 0n;
        message.offlineMaxDischargePower = 0n;
        message.onlineMaxChargePower = 0n;
        message.onlineMaxDischargePower = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* devices.v1.Timestamps timestamps */ 6:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* devices.v1.Device device */ 7:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* int64 offline_max_charge_power */ 8:
                    message.offlineMaxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 offline_max_discharge_power */ 9:
                    message.offlineMaxDischargePower = reader.int64().toBigInt();
                    break;
                case /* int64 online_max_charge_power */ 10:
                    message.onlineMaxChargePower = reader.int64().toBigInt();
                    break;
                case /* int64 online_max_discharge_power */ 11:
                    message.onlineMaxDischargePower = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* devices.v1.Timestamps timestamps = 6; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.Device device = 7; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int64 offline_max_charge_power = 8; */
        if (message.offlineMaxChargePower !== 0n)
            writer.tag(8, WireType.Varint).int64(message.offlineMaxChargePower);
        /* int64 offline_max_discharge_power = 9; */
        if (message.offlineMaxDischargePower !== 0n)
            writer.tag(9, WireType.Varint).int64(message.offlineMaxDischargePower);
        /* int64 online_max_charge_power = 10; */
        if (message.onlineMaxChargePower !== 0n)
            writer.tag(10, WireType.Varint).int64(message.onlineMaxChargePower);
        /* int64 online_max_discharge_power = 11; */
        if (message.onlineMaxDischargePower !== 0n)
            writer.tag(11, WireType.Varint).int64(message.onlineMaxDischargePower);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeviceConfiguredPowerLimits
 */
export const DeviceConfiguredPowerLimits = new DeviceConfiguredPowerLimits$Type();
//# sourceMappingURL=devices.js.map